import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { SidebarComponent } from "../sidebar/sidebar.component";
import { HeaderComponent } from "../header/header.component";

@Component({
  selector: "app-shell",
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, HeaderComponent],
  templateUrl: "./app-shell.component.html",
  styleUrl: "./app-shell.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppShellComponent {

}
